var fitmentSearch = {
    extraFields : null,
    year    : null,
    make    : null,
    model   : null,
    trim    : null,
    product_id  : null,
    
    init : function (container){

        "use strict";  
        $(container + ' .col-left').click(function(){
            $('.vehicles-form').toggleClass('show-form');
        });
        if($('.vehicles-form').hasClass('with-extra-fields')){
            fitmentSearch.extraFields = $(container).data('extra-fields');
            fitmentSearch.extraFields = JSON.parse(fitmentSearch.extraFields);    
        }
        
        $('.clear-selected-car').click(function(){
            var $this = $(this);
            $.ajax({
                type: "POST", 
                url: "/api/clear-choose-car-parts", 
                success:function(data){
                    if(data.status === 'ok'){
                        window.location.reload();
                    }else{
                        actionResponseModal(data.message,'error','.actions-block .save');   
                    }               
                }
            });
        });

        $(container  + ' select[data-plugin="select2"]').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    allowClear:true,
                    placeholder:data.placeholder
                },
                $select_name = $select.attr('name');

            if($('.vehicles-form-partial .filter-group').length > 0){
                options.dropdownParent = $('.vehicles-form-partial .filter-group');
            }

            if(data.ajax){
                
                options = $.extend({}, options ,{
                    ajax: {
                        dataType: 'json',
                        delay: 50,
                        data: function (params) {

                            var $param = params.term || '';
                            var additionals = {
                                product_id : fitmentSearch.product_id
                            };
                            
                            if($select_name == 'make'){
                                
                                additionals.year = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';

                            }else if($select_name == 'model'){

                                additionals.year = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';

                            }else if($select_name == 'trim'){

                                additionals.year = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';

                            }else if($select_name!='year'){

                                additionals.year = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';
                                additionals.trim = fitmentSearch.trim !== null   && typeof(fitmentSearch.trim.id) !=='undefined' ? fitmentSearch.trim.id : '';

                            }
                           
                            return {
                                route : data.ajax,
                                current_url : CURRENT_PATH,
                                q: data.search+'=@'+$param,
                                sort_term: data.search,
                                sort_way: data.search == 'YearID' ? 'DESC' : 'ASC',
                                limit : 200,
                                additionals : additionals,
                                page: params.page
                            }; 
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;                            
                            return {
                                results: data.data,
                                pagination: {
                                    more : (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    templateResult: function(d){

                        return d[data.search];
                    },
                    templateSelection: function(d){
                        if (data.id === '' ) { 
                            return data.placeholder;
                        }                        

                        fitmentSearch[ $select_name ] = {
                            id      : d['id'],
                            label   : data.search || d['id']
                        };
                        if(typeof(d[data.search])!=='undefined'){
                            d[data.search] = String(d[data.search]);
                        }

                        return d[data.search] || data.placeholder;
                    }
                });


            }
            $(this).select2(options).on('select2:open', function () {

                $(this).closest('.form-group').addClass('filled');

            }).on('select2:close', function () {
                if( $(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null ){
                    $(this).closest('.form-group').removeClass('filled');           
                }                     
            });

            $('.vehicles-form select').on('change', function (e) {

                fitmentSearch.selectChange( $(this).attr('name') , container);

            });
            

        });
        
    },
   
    selectChange: function( $select_name, container){

        "use strict";

        if($select_name === 'year'){

            var $field = "make";
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null);
            if($(container + " .group-"+$field+" select").val() !== null){
                $(container + " .group-"+$field+" select").trigger("change");
            }
            $(container + " .group-"+$field).removeClass('filled');
            $(container + " .group-"+$field).removeClass('disabled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html(''); 
            
            var $field = "model"; 
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null);
            if($(container + " .group-"+$field+" select").val() !== null){
                $(container + " .group-"+$field+" select").trigger("change");
            }
            $(container + " .group-"+$field).removeClass('filled');
            $(container + " .group-"+$field).addClass('disabled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html('');

            var $field = "trim";
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null).trigger("change");
            $(container + " .group-"+$field).removeClass('filled');
            $(container + " .group-"+$field).addClass('disabled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html('');

            fitmentSearch[ 'make' ]  = null;
            fitmentSearch[ 'model' ] = null;
            fitmentSearch[ 'trim' ]  = null;

            setTimeout(function(){
                if( !$(container + "  .group-make").hasClass('disabled') ){
                    $(container + "  .group-make select").select2('open');
                }
            },50);

        }else if($select_name ==='make'){

            var $field = "model";
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null);
            if($(container + " .group-"+$field+" select").val() !== null){
                $(container + " .group-"+$field+" select").trigger("change");
            }
            $(container + " .group-"+$field ).removeClass('filled');
            $(container + " .group-"+$field ).removeClass('disabled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html('');


            var $field = "trim";
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null);
            if($(container + " .group-"+$field+" select").val() !== null){
                $(container + " .group-"+$field+" select").trigger("change");
            }
            $(container + " .group-"+$field).removeClass('filled');
            $(container + " .group-"+$field).addClass('disabled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html('');

            fitmentSearch[ 'model' ] = null;
            fitmentSearch[ 'trim' ] = null;

            setTimeout(function(){
                if( !$(container + " .group-model").hasClass('disabled') ){
                    $(container + " .group-model select").select2('open');
                }
            },50);

        }else if($select_name ==='model'){

            var $field = "trim";
            $(container + " .group-"+$field+" select").select2('data', null);
            $(container + " .group-"+$field+" select").val(null);
            if($(container + " .group-"+$field+" select").val() !== null){
                $(container + " .group-"+$field+" select").trigger("change");
            }

            $(container + " .group-"+$field).removeClass('disabled');
            $(container + " .group-"+$field).removeClass('filled');
            $(container + " .group-"+$field+" .select2-selection__rendered").html('');

            fitmentSearch[ 'trim' ] = null;

            setTimeout(function(){
                if( !$(container + "  .group-trim").hasClass('disabled') ){
                    $(container + "  .group-trim select").select2('open');
                }
            },50);

        }else{
            
            fitmentSearch.selectExtra(container , $select_name);

            /*if($(container).hasClass('with-extra-fields')){                                
                
            }else{
                $(container +' .btn.clear-selected-car').addClass('hidden');
                $(container +' .btn[type="submit"]').removeClass('hidden'); 
            }*/
        }

    },

    selectExtra : function( container , $select_name  ){
      
        var next_field = $(container + " .group-"+$select_name).next().data('field');       

        if($(container + " .group-"+$select_name+" select").val() !== null && $(container + " .group-"+$select_name+" select").val() !== ""){
            
            if(next_field){
                
                $(container + "  .group-"+next_field+" select").select2('data', null);            
                $(container + " .group-"+next_field+" select").val(null);
                if($(container + " .group-"+next_field+" select").val() !== null){
                    //$(container + " .group-"+next_field+" select").trigger("change");
                }
                $(container + ' .group-'+next_field).removeClass('disabled');
                $(container + " .group-"+next_field).removeClass('filled');
                $(container + ' .group-'+next_field+' .select2-selection__rendered').html('');

                fitmentSearch[ next_field ] = null;

                setTimeout(function(){
                    if( !$(container + "  .group-"+next_field+"").hasClass('disabled') ){                        
                        $(container + "  .group-"+next_field+" select").select2('open');
                    }
                },50);

            }else{
                $(container +' .btn.clear-selected-car').addClass('hidden');
                $(container +' .btn[type="submit"]').removeClass('hidden'); 
            }
        }else{
            $(container +' .btn.clear-selected-car').addClass('hidden');
            $(container +' .btn[type="submit"]').removeClass('hidden'); 
        }
    },

    submit: function( form ){
        "use strict";
        $(form).parsley();
        $(form).on('submit',function($e){       
            $.ajax({
                url: '/api/choose-car-parts',
                data: $(form).serialize(),
                success: function (data) {

                    var t = [];
                    $(form).find('.select2-selection__rendered').each(function(){
                        t.push( $(this).text().replace(/[^0-9 a-z]/gi, '') );
                    })

                    try{
                        ga('global.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){}

                    try{
                        ga('local.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){}
              
                    if (data.status === "ok") {
                        if(data.redirect){
                            if($('body').hasClass('page-home')){
                                window.location = data.redirect;
                            }else{
                                window.location.reload();
                            }   
                        }else{
                            load_partial($('.vehiclesForm-partial'));
                        }                       
                    } else if (data.status === 'error') {
                        actionResponseModal(data.error,'error');
                    } else {
                        actionResponseModal(LOCALE.general_error,'error');
                    }
                }
            });         
            $e.preventDefault();
        });
    }
};

var fitmentSearchFilter = {
    year    : null,
    make    : null,
    model   : null,
    trim    : null,
    
    init : function (container){

//        $(container  + ' .disabled').removeClass('disabled');
        $(container  + ' select[data-plugin="select2"]').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder
                },
                $select_name = $select.attr('name');    

            if(data.ajax){ 

                options = $.extend({}, options ,{
                    ajax: {
                        dataType: 'json',
                        delay: 50,
                        data: function (params) {

                            var $param = params.term || '';
                            var additionals = {};

                            if($select_name == 'make'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';

                            }else if($select_name == 'model'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';

                            }else if($select_name == 'trim'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';

                            }else  if($select_name != 'year'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';
                                additionals.trim  = fitmentSearch.trim !== null   && typeof(fitmentSearch.trim.id) !=='undefined' ? fitmentSearch.trim.id : '';

                            }
                            
                            
                            return {
                                route:data.ajax,
                                current_url : CURRENT_PATH,
                                q: data.search+'=@'+$param,
                                sort_term: data.search,
                                sort_way: data.search == 'YearID' ? 'DESC' : 'ASC',
                                limit : 200,
                                additionals : additionals,
                                page: params.page || 1
                            }; 
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;                            
                            return {
                                results: data.data,
                                pagination: {
                                    more : (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    templateResult: function(d){
                        return d[data.search];
                    },
                    templateSelection: function(d){
                        if (data.id === '' ) { // adjust for custom placeholder values
                            return data.placeholder;
                        }
                        fitmentSearch[ $select_name ] = {
                            id      : d['id'],
                            label   : data.search || d['id']
                        };
                        if(typeof(d[data.search])!=='undefined'){
                            d[data.search] = String(d[data.search]);
                        }
                        return d[data.search] || data.placeholder;
                    }
                });
            }
            $(this).select2(options).on('select2:open', function () {
                $(this).closest('.form-group').addClass('filled');

            }).on('select2:close', function () {
                var is_filled = !($(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null);
                if( is_filled ){
                    $(this).closest('.form-group').addClass('filled');    
                } else {
                    $(this).closest('.form-group').removeClass('filled');            
                }
            });

            $select.on('change', function (e) {
                fitmentSearchFilter.selectChange( $select_name , container);
            });

        });
        $(container + ' .col-left').click(function(){
            $('.vehicles-form').toggleClass('show-form');
        });
        

        $('.clear-selected-car').click(function(){
            var $this = $(this);
            $.ajax({
                type: "POST", 
                url: "/api/clear-choose-car-parts", 
                success:function(data){
                    if(data.status === 'ok'){
                        window.location.reload();
                    }else{
                        actionResponseModal(data.message,'error','.actions-block .save');   
                    }               
                }
            });
        });
    },

    emptyGroup: function($select_name, container) {
        var found = false;
        var signal_next = false;
        var next = null;
        $(container + " .form-group").each(function(i) {
            var $this = $(this);

            // we've been told to open this select box
            if (signal_next) {
                signal_next = false;
                setTimeout(function(){
                    if( !$this.hasClass('disabled') ){
                        $this.find("select").select2('open');
                    }
                },50);
            }

            // we found the current element. the next one should open
            if (!found && !signal_next && $this.hasClass("group-" + $select_name)) {
                signal_next = true;
            }

            // if we _previously_ found the matching element...
            if (found) {
                $this.find("select").select2('data', null);
                $this.find("select").empty();
                $this.find("select").val(null);
                $this.removeClass('filled');
                $this.removeClass('disabled');
                $this.find(" .select2-selection__rendered").html('');
            }

            found = found || $this.hasClass("group-" + $select_name);
        });
    },
    selectChange: function( $select_name, container){
        fitmentSearchFilter.emptyGroup( $select_name , container);
    },
    submit: function( form ){
        
        $(form).on('submit',function($e){ 

            $e.preventDefault();  
            var $partial = $('.vehicles-partial');
            var data = {};

            $(form).find('input').each(function(){
                var n = $(this).attr('name');
                var v = $(this).val();
                $partial.data(n,v);                    
            });
            
            $(form).find('select').each(function(){
                var n = $(this).attr('name');
                var v = $(this).val();
                data[n] = v;
                $partial.data(n,v);
            });

            var t = [];
            $(form).find('.select2-selection__rendered').each(function(){
                t.push( $(this).text().replace(/[^0-9 a-z]/gi, '') );
            })

            try{
                ga('global.send', 'event', 'Vehicles', 'Search', t.join(' '));
            }catch(Error){}

            try{
                ga('local.send', 'event', 'Vehicles', 'Search', t.join(' '));
            }catch(Error){}
           
            load_partial($partial);            
            $e.preventDefault();            
        });
    }
};



var fitmentSearchFilterFull = {
    year    : null,
    make    : null,
    model   : null, 
    trim    : null,
    
    init : function (container){
        
      //  $(container  + ' .disabled').removeClass('disabled');
        $(container  + ' select[data-plugin="select2"]').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder
                },
                $select_name = $select.attr('name');    

            if(data.ajax){ 

                options = $.extend({}, options ,{
                    ajax: {
                        dataType: 'json',
                        delay: 50,
                        data: function (params) {

                            var $param = params.term || '';
                            var additionals = {};

                            if($select_name == 'make'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';

                            }else if($select_name == 'model'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';

                            }else if($select_name == 'trim'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';

                            }else  if($select_name != 'year'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';
                                additionals.trim  = fitmentSearch.trim !== null   && typeof(fitmentSearch.trim.id) !=='undefined' ? fitmentSearch.trim.id : '';

                            }
                            
                            
                            return {
                                route:data.ajax,
                                current_url : CURRENT_PATH,
                                q: data.search+'=@'+$param,
                                sort_term: data.search,
                                sort_way: data.search == 'YearID' ? 'DESC' : 'ASC',
                                limit : 200,
                                additionals : additionals,
                                page: params.page || 1
                            }; 
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;                            
                            return {
                                results: data.data,
                                pagination: {
                                    more : (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    templateResult: function(d){
                        return d[data.search];
                    },
                    templateSelection: function(d){
                        if (data.id === '' ) { // adjust for custom placeholder values
                            return data.placeholder;
                        }
                        fitmentSearch[ $select_name ] = {
                            id      : d['id'],
                            label   : data.search || d['id']
                        };
                        if(typeof(d[data.search])!=='undefined'){
                            d[data.search] = String(d[data.search]);
                        }
                        return d[data.search] || data.placeholder;
                    }
                });
            }
            $(this).select2(options).on('select2:open', function () {
                $(this).closest('.form-group').addClass('filled');

            }).on('select2:close', function () {
                var is_filled = !($(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null);
                if( is_filled ){
                    $(this).closest('.form-group').addClass('filled');    
                } else {
                    $(this).closest('.form-group').removeClass('filled');            
                }
            });

            $select.on('change', function (e) {
                fitmentSearchFilterFull.selectChange( $select_name , container);
            });

        });
        $(container + ' .col-left').click(function(){
            $('.vehicles-form').toggleClass('show-form');
        });
        

        $('.clear-selected-car').click(function(){
            var $this = $(this);
            $.ajax({
                type: "POST", 
                url: "/api/clear-choose-car-parts", 
                success:function(data){
                    if(data.status === 'ok'){
                        window.location.reload();
                    }else{
                        actionResponseModal(data.message,'error','.actions-block .save');   
                    }               
                }
            });
        });
    },

    emptyGroup: function($select_name, container) {
        var found = false;
        var signal_next = false;
        var next = null;
        $(container + " .form-group").each(function(i) {
            var $this = $(this);

            // we've been told to open this select box
            if (signal_next) {
                signal_next = false;
                setTimeout(function(){
                    if( !$this.hasClass('disabled') ){
                        $this.find("select").select2('open');
                    }
                },50);
            }

            // we found the current element. the next one should open
            if (!found && !signal_next && $this.hasClass("group-" + $select_name)) {
                signal_next = true;
            }

            // if we _previously_ found the matching element...
            if (found) {
                $this.find("select").select2('data', null);
                $this.find("select").empty();
                $this.find("select").val(null);
                $this.removeClass('filled');
                $this.removeClass('disabled');
                $this.find(" .select2-selection__rendered").html('');
            }

            found = found || $this.hasClass("group-" + $select_name);
        });
    },
    selectChange: function( $select_name, container){
        fitmentSearchFilterFull.emptyGroup( $select_name , container);

    },

    submit: function( form ){
        $(form).on('submit',function($e){    

            $.ajax({
                url: '/api/choose-car-parts',
                data: $(form).serialize(),
                success: function (data) {

                    var t = [];
                    $(form).find('.select2-selection__rendered').each(function(){
                        t.push( $(this).text().replace(/[^0-9 a-z]/gi, '') );
                    });

                    try{
                        ga('global.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){}

                    try{
                        ga('local.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){} 
              
                    if (data.status === "ok") {
                        window.location.reload();                     
                    } else if (data.status === 'error') {
                        actionResponseModal(data.error,'error');
                    } else {
                        actionResponseModal(LOCALE.general_error,'error');
                    }
                }
            });         
            $e.preventDefault();
        });
    }
};


var fitmentSearchDetails = {
    year        : null,
    make        : null,
    model       : null,
    trim        : null,
    product_id  : null,
     
    init : function (container){
 
        //$(container  + ' .disabled').removeClass('disabled');
        $(container  + ' select[data-plugin="select2"]').each(function(){

            var $select = $(this),
                data = $select.data(),
                options = {
                    placeholder:data.placeholder
                },
                $select_name = $select.attr('name');    

            if(data.ajax){ 

                options = $.extend({}, options ,{
                    ajax: {
                        dataType: 'json',
                        delay: 50,
                        data: function (params) {

                            var $param = params.term || '';
                            var additionals = {
                                product_id : fitmentSearchDetails.product_id
                            };
                            
                            if($select_name == 'make'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';

                            }else if($select_name == 'model'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';

                            }else if($select_name == 'trim'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';

                            }else  if($select_name != 'year'){
                                additionals.year  = fitmentSearch.year !== null   && typeof(fitmentSearch.year.id) !=='undefined' ? fitmentSearch.year.id : '';
                                additionals.make  = fitmentSearch.make !== null   && typeof(fitmentSearch.make.id) !=='undefined' ? fitmentSearch.make.id : '';
                                additionals.model = fitmentSearch.model !== null   && typeof(fitmentSearch.model.id) !=='undefined' ? fitmentSearch.model.id : '';
                                additionals.trim  = fitmentSearch.trim !== null   && typeof(fitmentSearch.trim.id) !=='undefined' ? fitmentSearch.trim.id : '';

                            }
                            
                            
                            return {
                                route:data.ajax,
                                current_url : CURRENT_PATH,
                                q: data.search+'=@'+$param,
                                sort_term: data.search,
                                sort_way: data.search == 'YearID' ? 'DESC' : 'ASC',
                                limit : 200,
                                additionals : additionals,
                                page: params.page || 1
                            }; 
                        },
                        processResults: function (data, params) {
                            params.page = params.page || 1;                            
                            return {
                                results: data.data,
                                pagination: {
                                    more : (params.page * 30) < data.total_count
                                }
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    templateResult: function(d){
                        return d[data.search];
                    },
                    templateSelection: function(d){
                        if (data.id === '' ) { // adjust for custom placeholder values
                            return data.placeholder;
                        }
                        fitmentSearch[ $select_name ] = {
                            id      : d['id'],
                            label   : data.search || d['id']
                        };
                        if(typeof(d[data.search])!=='undefined'){
                            d[data.search] = String(d[data.search]);
                        }
                        return d[data.search] || data.placeholder;
                    }
                });
            }
            $(this).select2(options).on('select2:open', function () {
                $(this).closest('.form-group').addClass('filled');

            }).on('select2:close', function () {
                var is_filled = !($(this).val() == '0' || $(this).val() == '' || $(this).val() == 'undefined' || $(this).val() == null);
                if( is_filled ){
                    $(this).closest('.form-group').addClass('filled');    
                } else {
                    $(this).closest('.form-group').removeClass('filled');            
                }
            });

            $select.on('change', function (e) {
                fitmentSearchDetails.selectChange( $select_name , container);
            });

        });
        $(container + ' .col-left').click(function(){
            $('.vehicles-form').toggleClass('show-form');
        });
        

        $('.clear-selected-car').click(function(){
            var $this = $(this);
            $.ajax({
                type: "POST", 
                url: "/api/clear-choose-car-parts", 
                success:function(data){
                    if(data.status === 'ok'){
                        window.location.reload();
                    }else{
                        actionResponseModal(data.message,'error','.actions-block .save');   
                    }               
                }
            });
        });
    },

    emptyGroup: function($select_name, container) {
        var found = false;
        var signal_next = false;
        var next = null;
        $(container + " .form-group").each(function(i) {
            var $this = $(this);

            // we've been told to open this select box
            if (signal_next) {
                signal_next = false;
                setTimeout(function(){
                    if( !$this.hasClass('disabled') ){
                        $this.find("select").select2('open');
                    }
                },50);
            }

            // we found the current element. the next one should open
            if (!found && !signal_next && $this.hasClass("group-" + $select_name)) {
                signal_next = true;
            }

            // if we _previously_ found the matching element...
            if (found) {
                $this.find("select").select2('data', null);
                $this.find("select").empty();
                $this.find("select").val(null);
                $this.removeClass('filled');
                $this.removeClass('disabled');
                $this.find(" .select2-selection__rendered").html('');
            }

            found = found || $this.hasClass("group-" + $select_name);
        });
    },
    selectChange: function( $select_name, container){
        fitmentSearchDetails.emptyGroup( $select_name , container);

    },
    submit: function( form ){
        $(form).on('submit',function($e){    

            $.ajax({
                url: '/api/choose-car-parts',
                data: $(form).serialize(),
                success: function (data) {

                    var t = [];
                    $(form).find('.select2-selection__rendered').each(function(){
                        t.push( $(this).text().replace(/[^0-9 a-z]/gi, '') );
                    });

                    try{
                        ga('global.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){}

                    try{
                        ga('local.send', 'event', 'Vehicles', 'Search', t.join(' '));
                    }catch(Error){} 
              
                    if (data.status === "ok") {
                        window.location.reload();                     
                    } else if (data.status === 'error') {
                        actionResponseModal(data.error,'error');
                    } else {
                        actionResponseModal(LOCALE.general_error,'error');
                    }
                }
            });         
            $e.preventDefault();
        });
    }
    
};

                        
